// src/services/providers/BasePaymentProvider.js

function BasePaymentProvider(config) {
    this.config = config || {};
    this.initialized = false;
    this.name = 'base';
}

BasePaymentProvider.prototype.initialize = function() {
    return new Promise(function(resolve) {
        this.initialized = true;
        resolve();
    }.bind(this));
};

BasePaymentProvider.prototype.isInitialized = function() {
    return this.initialized;
};

BasePaymentProvider.prototype.validateConfig = function() {
    return [];
};

/**
 * Инициализация платежа (вызывается из контекста)
 * Должен вернуть данные для бэкенда
 */
BasePaymentProvider.prototype.initPayment = function(orderData, userData) {
    return Promise.reject(new Error('initPayment method must be implemented'));
};

/**
 * Выполнение реального платежа (для провайдеров с виджетом)
 * Опциональный метод
 */
BasePaymentProvider.prototype.executePayment = function(paymentData) {
    return Promise.reject(new Error('executePayment method not supported by this provider'));
};

/**
 * Подтверждение платежа
 */
BasePaymentProvider.prototype.confirmPayment = function(paymentData) {
    return Promise.reject(new Error('confirmPayment method must be implemented'));
};

/**
 * Отмена платежа
 */
BasePaymentProvider.prototype.cancelPayment = function(paymentId) {
    return Promise.reject(new Error('cancelPayment method must be implemented'));
};

/**
 * Получение статуса платежа
 */
BasePaymentProvider.prototype.getPaymentStatus = function(paymentId) {
    return Promise.reject(new Error('getPaymentStatus method must be implemented'));
};

/**
 * Валидация данных заказа
 */
BasePaymentProvider.prototype.validatePaymentData = function(orderData, userData) {
    var errors = [];

    if (!orderData || typeof orderData !== 'object') {
        errors.push('Invalid order data');
        return errors;
    }

    if (!orderData.amount || orderData.amount <= 0) {
        errors.push('Invalid order amount');
    }

    if (!orderData.id) {
        errors.push('Order ID is required');
    }

    if (!userData || !userData.id) {
        errors.push('User ID is required');
    }

    return errors;
};

/**
 * Генерация чека
 */
BasePaymentProvider.prototype.generateCustomerReceipt = function(orderData) {
    var items = Array.isArray(orderData.items) ? orderData.items : [];

    return {
        taxationSystem: 0,
        amount: {
            total: orderData.amount || 0,
            discount: 0
        },
        items: items.map(function(item) {
            return {
                label: item.name ? String(item.name).substring(0, 128) : 'Товар',
                price: Number(item.price) || 0,
                quantity: Number(item.quantity) || 1,
                amount: (Number(item.price) || 0) * (Number(item.quantity) || 1),
                vat: Number(item.vat) || 20,
                method: 1,
                object: 1
            };
        }),
        email: orderData.userEmail || '',
        phone: orderData.userPhone || '',
        place: orderData.restaurantName || 'Ресторан'
    };
};

/**
 * Обработка ошибок
 */
BasePaymentProvider.prototype.handleError = function(error, context) {
    console.error('[' + this.name + '] Error in ' + (context || '') + ':', error);

    var errorMap = this.getErrorMap();
    var message = errorMap[error.code] || error.message || 'Unknown payment error';

    return {
        success: false,
        error: message,
        code: error.code,
        context: context
    };
};

/**
 * Карта ошибок
 */
BasePaymentProvider.prototype.getErrorMap = function() {
    return {
        'INSUFFICIENT_FUNDS': 'Недостаточно средств на карте',
        'LIMIT_EXCEEDED': 'Превышен лимит по карте',
        'CARD_DECLINED': 'Карта отклонена',
        'NETWORK_ERROR': 'Ошибка сети. Попробуйте позже'
    };
};

/**
 * Получить компонент виджета для провайдера
 * Переопределяется в дочерних классах
 */
BasePaymentProvider.prototype.getWidget = function() {
    return null; // null означает "использовать дефолтный"
};

/**
 * Имя виджета
 */
BasePaymentProvider.prototype.getWidgetName = function() {
    return this.widgetName || 'base';
};

export { BasePaymentProvider };